import { BooleanFilter } from "./boolean-filter";
import { IntegerFilter } from "./integer-filter";
import { StringFilter } from "./string-filter";

export class PersonnelFilter {
    public id?: IntegerFilter;
    public fullName?: StringFilter;
    public firstName?: StringFilter;
    public lastName?: StringFilter;
    public email?: StringFilter;
    public aadId?: StringFilter;
    public state?: StringFilter;
    public isActive?: BooleanFilter;
}
